




import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class Regular extends Vue {
  @Getter('access') access
  @Getter('trialExpired', { namespace: 'user' }) trialExpired

  created() {
    if (this.trialExpired) {
      this.$router.push({ name: 'trial-expired' })
    } else {
      this.$router.push({ name: 'download-app', query: this.$route.query })
    }
  }
}
